/* =========================================================================
   ATELIER COLLECTION: Header Gap Engine & Variant Logic
   ========================================================================= */
document.addEventListener('DOMContentLoaded', function() {
  
  // --- 1. HEADER GAP ENGINE ---
  const header = document.querySelector('sticky-header, .site-header, [id*="shopify-section-header"]');
  const sectionEl = document.querySelector('.js-collection-section'); 
  let ticking = false;

  const updateHeaderGap = () => {
    if (!sectionEl) return;
    
    if (!header) {
      sectionEl.style.setProperty('--atelier-header-gap', '135px');
      return;
    }

    const headerBottom = header.getBoundingClientRect().bottom;
    const gap = Math.max(0, headerBottom); 
    
    sectionEl.style.setProperty('--atelier-header-gap', gap + 'px');
    ticking = false;
  };

  if (header && sectionEl) {
    window.addEventListener('scroll', function() {
      if (!ticking) {
        window.requestAnimationFrame(updateHeaderGap);
        ticking = true;
      }
    }, { passive: true });
    window.addEventListener('resize', updateHeaderGap, { passive: true });
    updateHeaderGap(); 
  }


  // --- 2. VARIANT LOGIC & ADD TO CART ---
  const forms = document.querySelectorAll('.js-collection-form');

  function formatPence(priceString) {
    if (!priceString.includes('.')) return priceString;
    const parts = priceString.split('.');
    return `${parts[0]}<span class="atelier-price__pence">.${parts[1]}</span>`;
  }

  forms.forEach(form => {
    const hiddenInput = form.querySelector('input[name="id"]');
    const priceDisplay = form.querySelector('.js-collection-price');
    const variantBtns = form.querySelectorAll('.js-variant-btn');
    
    // Safety Check: Force the hidden input to populate on initial load
    const initialActiveBtn = form.querySelector('.js-variant-btn.is-active') || variantBtns[0];
    if (initialActiveBtn && hiddenInput) {
      hiddenInput.value = initialActiveBtn.dataset.variantId;
    }

    const section = form.closest('.js-collection-section');
    
    // Variant Button Click
    variantBtns.forEach(btn => {
      btn.addEventListener('click', function() {
        if (this.disabled) return;

        variantBtns.forEach(b => b.classList.remove('is-active'));
        this.classList.add('is-active');
        
        // Update the core ID value
        if (hiddenInput) hiddenInput.value = this.dataset.variantId;

        if (priceDisplay) {
          priceDisplay.innerHTML = formatPence(this.dataset.priceFormatted);
        }

        // --- 4. BROADCAST VARIANT CHANGE (Decoupled Logic) ---
        const selectedVariantId = this.dataset.variantId;
        document.dispatchEvent(new CustomEvent('Atelier:VariantChanged', {
          detail: { variantId: selectedVariantId }
        }));
        
        // --- 5. UPDATE URL ---
        window.history.replaceState({ }, '', `${window.location.pathname}?variant=${this.dataset.variantId}`);
      });
    });

    // --- BULLETPROOF ADD TO CART ---
    const ctaButtons = section.querySelectorAll('.atelier-add-btn, button[type="submit"]');
    
    ctaButtons.forEach(btn => {
      btn.addEventListener('click', async function(e) {
        e.preventDefault(); // Stop native form submission
        
        const variantId = hiddenInput ? hiddenInput.value : null;
        if (!variantId) return;

        // UI Loading State
        const originalText = btn.textContent;
        btn.classList.add('is-loading');
        btn.disabled = true;
        btn.textContent = 'Adding...';

        try {
          const res = await fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ id: variantId, quantity: 1 })
          });
          
          if (!res.ok) throw new Error('Failed to add');
          
          // Success! Send them to the cart
          window.location.href = window.Shopify.routes.root + 'cart';
        } catch (err) {
          btn.classList.remove('is-loading');
          btn.disabled = false;
          btn.textContent = originalText;
          alert('Could not add to cart. Please try again.');
        }
      });
    });
  });
});